import start from './src/start';
import news_cards from './src/news-card';

start();
// tooltips();

const menu_categorie = document.querySelector('.menu-categorie'),
  menu_categorie_summary = menu_categorie.querySelector('summary'),

  // il tag summary è nascosto in modalità desktop
  check_is_desktop = () => menu_categorie_summary.offsetHeight === 0,

  open_menu_categorie = () => {
    menu_categorie.setAttribute('open', true);
  };

if( check_is_desktop() ) {
  open_menu_categorie();
}

const resizeObserver = new ResizeObserver(() => {
  if( check_is_desktop() ) {
    open_menu_categorie();
  }
});

resizeObserver.observe(menu_categorie_summary);

news_cards();
